import React from 'react';
import {
  compose,
  withStateHandlers,
  withHandlers,
  lifecycle,
  StateHandler,
  StateHandlerMap,
} from 'recompose';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import CampaignsCRUDActions from '@mm/state/actions/CampaignsCRUDActions';
import ChatBlastReportTable from '../ChatBlastReportTable/ChatBlastReportTable';
import { StoreState } from '@mm/state/store-interfaces';
import { LifeCycleThis } from '@mm/utils';
import { orderedRecipientsSelector } from '@mm/state/modules/recipientsTableState/selectors';
import './ChatBlastReportRecipients.scss';

type OuterProps = {
  campaignId: number;
};

type StateProps = {
  contacts: any;
};

type Handlers = {
  onChangePagination: (pagingNumber: number) => void;
};

type StateHandlerProps = StateHandlerMap<StateProps> & {
  setContacts(contacts: any): StateHandler<StateProps>;
};

type MapStateToPropsType = ReturnType<typeof mapStateToProps>;
type MapDispatchToPropsType = ReturnType<typeof mapDispatchToProps>;

type InnerProps = StateProps &
  StateHandlerProps &
  MapStateToPropsType &
  Handlers &
  MapDispatchToPropsType;

type Props = OuterProps & InnerProps;

const PAGE_SIZE = 10;

const mapStateToProps = (state: StoreState) => ({
  trackings: orderedRecipientsSelector(state),
  pagination: state.campaigns.trackings.pagination,
});

const mapDispatchToProps = (dispatch: Dispatch<StoreState>) => ({
  getTracking: (campaignId: number, pageNumber: number) =>
    dispatch(
      CampaignsCRUDActions.retrieveChatBlasterTracking(
        campaignId,
        pageNumber,
        PAGE_SIZE,
      ),
    ),
});

const initialState = {
  contacts: [],
};

const stateUpdaters = {
  setContacts: () => contacts => ({ contacts }),
};

function componentDidMount(this: LifeCycleThis<Props>) {
  const { getTracking, campaignId } = this.props;
  getTracking(campaignId, 1);
}

const onChangePagination = (props: Props) => (pagingNumber: number) => {
  const { getTracking, campaignId } = props;
  getTracking(campaignId, pagingNumber);
};

const enhance = compose<InnerProps, OuterProps>(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({ onChangePagination }),
  withStateHandlers(initialState, stateUpdaters),
  lifecycle<Props, {}>({ componentDidMount }),
);

const ChatBlastReportRecipients = (props: Props) => {
  const { pagination, trackings, onChangePagination } = props;

  return (
    <div className="blast-report-recipients">
      <div className="blast-report-recipients__header">
        <h3 className="blast-report-recipients__label">Recipients</h3>
      </div>
      <div className="blast-report-recipients__table-wrapper">
        {trackings && pagination && (
          <ChatBlastReportTable
            campaignsUsers={trackings}
            pagination={pagination}
            onChangePagination={onChangePagination}
          />
        )}
      </div>
    </div>
  );
};

export default enhance(ChatBlastReportRecipients);
